export enum RolePermissionType {
    AdministerWorkflow = 0,
    ModifyAndMaintainEmailTemplates = 1,
    RunReports = 2,
    ManageUser = 3,
    CreateNewForms = 4,
    ModifyForms = 5,
    Deployments = 6,
    ViewEncryptedData = 7,
    ViewSsearchUsersOfYourOwnOrg = 8,
    ViewCurrentForms = 9,
    ViewHistoricForms = 10,
    ReAssignForms = 11,
    AssignFormsToUsers = 12,
    ViewDUNSForms = 13,
    EditMyForms = 14,
    EditAllOrgForms = 15,
    SubmitForms = 16,
    UpdateRolesForUsers = 17,
    ViewRequestedForms = 18,
    ViewDraftRevisionForms = 19,
    UnlockForms = 20,
    ViewReAssignmentHisotryOfForms = 21,
    ManageSettings = 22,
    ManageRoleDefinitions = 23,
    ManageAlerts = 24,
    ManageLogs = 25,
    ViewReportDefinitions = 26,
    ViewDataIntegration = 27,
    ManageGeneralSettings = 28,
    ManageNotifications = 29,
    ManageApprovalWorkflow = 1001,
    Approver = 1002,
    SendFormRequest = 1003,
    ManageAttribute = 1004,
    ManageFormSets = 1007
}

